import React, { useState } from 'react';

import Popover from '~/components/ui/atoms/Popover';
import usePopoverState from '~/components/ui/atoms/Popover/usePopoverState';

import DropDownIcon from '../../../icons/editor/DropDownIcon';

import ToolbarButton from './ToolbarButton';

export interface OptionProps {
  isActive: boolean;
  disabled: boolean;
  onClick: () => void;
  content: React.ReactNode;
}

export interface MultiOptionProps {
  options: OptionProps[];
  initial?: number;
  /** Names the trigger, which shows only the selected option's icon, and the popover. */
  label: string;
}

const MultiOptions: React.FC<MultiOptionProps> = ({ options, initial = 0, label }) => {
  const [selected, setSelected] = useState(initial);
  const { triggerProps, popoverProps, close } = usePopoverState();

  const handleOptionClick = (index: number) => {
    options[index].onClick();
    setSelected(index);
    close();
  };

  return (
    <>
      <ToolbarButton disabledHoverEffect aria-label={label} {...triggerProps}>
        <div className="inline-flex items-center">
          {options[selected].content}
          <DropDownIcon className="ml-4" size={12} />
        </div>
      </ToolbarButton>
      <Popover {...popoverProps} aria-label={label} align="start">
        <div>
          {options.map(({ isActive, disabled, content }, index) => (
            <ToolbarButton key={index} isActive={isActive} disabled={disabled} onClick={() => handleOptionClick(index)}>
              {content}
            </ToolbarButton>
          ))}
        </div>
      </Popover>
    </>
  );
};

export default MultiOptions;
